import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,
                private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const error = err.error?.message || err.statusText;
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();

                Swal.fire({
                    title: 'Sesión Finalizada',
                    html: `
                    <div style="font-family: 'Segoe UI', sans-serif; text-align: center; padding: 6px 12px;">
                      <div style="
                        width: 160px; height: 160px; margin: 0 auto 14px;
                        border-radius: 50%;
                        display: flex; align-items: center; justify-content: center;
                        background: linear-gradient(180deg, #ffffff 0%, #f2fbff 100%);
                        box-shadow: 0 6px 18px rgba(10, 31, 68, 0.08);
                      ">
                        <img
                          src="/assets/images/avatarsys2023.png"
                          alt="AVATAR.SYS"
                          style="
                            display: block;
                            width: auto;
                            height: auto;
                            max-width: 120px;
                            max-height: 120px;
                            object-fit: contain;
                          "
                          loading="lazy"
                        />
                      </div>
              
                      <p style="color: #2c3e50; font-size: 16px; font-weight: 500; margin: 6px 0 4px;">
                      `+ error +`
                      </p>
              
                      <p style="color: #7f8c8d; font-size: 13px; margin: 0 0 12px;">
                        Serás redirigido al inicio de sesión.
                      </p>
              
                      <div style="
                        margin-top: 6px; padding: 10px 14px;
                        background: #eaf6fb; border-left: 4px solid #1a9fd4;
                        border-radius: 6px; text-align: center; display: inline-flex;
                        align-items: center; gap: 8px;
                      ">
                        <span style="font-size: 12px; color: #1a9fd4; font-weight: 700;">
                          AVATAR.SYS — Acceso Seguro
                        </span>
                      </div>
                    </div>
                  `,
                    showConfirmButton: true,
                    confirmButtonText: 'Iniciar Sesión',
                    confirmButtonColor: '#1a9fd4',
                    background: '#ffffff',
                    color: '#2c3e50',
                    timerProgressBar: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        title: 'swal-avatar-title',
                        popup: 'swal-avatar-popup'
                    },
                    didOpen: () => {
                        const title = Swal.getTitle();
                        if (title) {
                            title.style.color = '#1a9fd4';
                            title.style.fontWeight = '700';
                            title.style.fontSize = '20px';
                        }
                    },
                    footer: `<span style="color: #aaa; font-size: 11px;">© 2026 AVATARSYS 1.0 — Todos los derechos reservados</span>`
                }).then(() => {
                    this.router.navigate(['/account/login']);
                });
//                location.reload();
                return EMPTY;
            }
            return throwError(error);
        }));
    }
}